import { Component, OnInit } from '@angular/core';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PerfilService } from '../../../shared/services/apis/usuario-admin/perfil.service';
import { ListaPerfilResponse } from '../../../shared/services/responses/usuario-admin/lista-perfil.response';
import { UsuarioAdminService } from '../../../shared/services/apis/usuario/usuario-admin.service';
import { ListaUsuarioResponse } from '../../../shared/services/responses/usuario/lista-usuario.response';
import { ListaEmpresaAdminResponse } from '../../../shared/services/responses/usuario/lista-empresa-admin.response';
import { ListaEmpresaAdminService } from '../../../shared/services/apis/usuario/lista-empresa-admin.service';
import { MatSelectModule } from '@angular/material/select';
import { SuperAcessoRequest } from '../../../shared/services/requests/usuario-admin/super-acesso.request';
import { SuperAcessoService } from '../../../shared/services/apis/usuario-admin/super-acesso.service';
import { ListaSuperAcessoResponse } from '../../../shared/services/responses/usuario-admin/lista-super-acesso.response';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { PermissaoEnum } from '../../../shared/enums/permissao.enum';
import { TemPermissaoDirective } from '../../../shared/directives/habilita-por-permissao.directive';
import { UsuarioListaStruct } from '../../../shared/services/structs/usuario/usuario-lista.struct';
import { Empresa } from '../../../shared/services/models/usuario/empresa.model';
import { forkJoin, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';

export class AppModule {}

@Component({
  selector: 'app-super-acesso-lista',
  imports: [
    MenuComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    CommonModule,
    MatTableModule,
    LoadingBoxComponent,
    RouterModule,
    EmptyListComponent,
    MatTooltipModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    TemPermissaoDirective,
    SelectPesquisavelComponent,
  ],
  templateUrl: './super-acesso-lista.component.html',
  styleUrl: './super-acesso-lista.component.css',
})
export class SuperAcessoListaComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;
  

  constructor(
    private formBuilder: FormBuilder,
    private usuarioAdminService: UsuarioAdminService,
    private perfilService: PerfilService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private listaEmpresaAdminService: ListaEmpresaAdminService,
    private superAcessoService: SuperAcessoService,
    private listaUsuarioAdminService: UsuarioAdminService
  ) {
    this.moduloEnum = ModuloEnum.Suporte;
    this.funcionalidadeEnum = FuncionalidadeEnum.Suporte_SuperAcesso;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaPerfilResponse: ListaPerfilResponse | undefined;
  public displayedColumns: string[] = ['idEmpresa', 'idUsuario', 'descricao', 'data'];
  public _dataSource = new MatTableDataSource<SuperAcessoRequest>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;
  public _usuarioLookupResponse: ListaUsuarioResponse;
  public _empresaLookupResponse: ListaEmpresaAdminResponse;
  public _listaSuperAcessoResponse: ListaSuperAcessoResponse;
  public _PermissaoEnum = PermissaoEnum;
  public _urlListEmpresa: string;
  public preloadedEmpresa: any;

  async ngOnInit(): Promise<void> {
    this._urlListEmpresa = environment.urlApiUsuario + "ListaEmpresaAdmin"; 
    this.model = this.formBuilder.group({
      listaIdUsuario: new FormControl({ value: '', disabled: true }),
      descricaoAcesso: new FormControl({ value: '', disabled: false }),
      listaIdEmpresa: new FormControl({ value: '', disabled: false }),
      linkSuperAcesso: new FormControl(),
      datetimeInclusao: new FormControl({ value: '', disabled: false }),
    });
    await this.pesquisar();
  }

  pesquisar(): void {
    if (this.model.invalid || this._isLoading) {
      return;
    }

    this._isLoading = true;

    const superAcessoRequest: SuperAcessoRequest = new SuperAcessoRequest();
    superAcessoRequest.idEmpresa = this.model.get('listaIdEmpresa')?.value || null;
    superAcessoRequest.idUsuario = this.model.get('listaIdUsuario')?.value || null;

    if (!this.model.get('datetimeInclusao')?.value) {
      superAcessoRequest.datahoraInclusao = null;
    } else {
      superAcessoRequest.datahoraInclusao = new Date(this.model.get('datetimeInclusao')?.value || null);
    }

    this.superAcessoService.ObterListaSuperAcesso(superAcessoRequest, this._paginaAtual).subscribe({
      next: (listaSuperAcessoResponse: ListaSuperAcessoResponse) => {
        if (listaSuperAcessoResponse.isError) {
          this.alertService.show('Erro', listaSuperAcessoResponse.errorDescription, AlertType.error);
          return;
        }
        this._isLoading = false;

        if (listaSuperAcessoResponse.isError) {
          this.alertService.show('Erro', listaSuperAcessoResponse.errorDescription, AlertType.error);
          return;
        }

        this._ultimaPagina = true;

        if (!this._listaSuperAcessoResponse) {
          this._ultimaPagina = false;
        }

        this._listaSuperAcessoResponse = listaSuperAcessoResponse;

        const listIdUsuario: number[] = Array.from(
          new Set(listaSuperAcessoResponse.listaSuperAcesso.map(item => item.idUsuario))
        );
        const listIdEmpresa: number[] = Array.from(
          new Set(listaSuperAcessoResponse.listaSuperAcesso.map(item => item.idEmpresa))
        );

        const observableUsuario: Observable<ListaUsuarioResponse> =
          this.listaUsuarioAdminService.post(listIdUsuario);
        const observableEmpresa: Observable<ListaEmpresaAdminResponse> =
          this.listaEmpresaAdminService.post(listIdEmpresa);

        forkJoin([observableUsuario, observableEmpresa]).subscribe({
          next: ([respostaUsuario, respostaEmpresa]) => {
            if (respostaUsuario.isError) {
              this.alertService.show(
                'Erro ao buscar dados do usuário',
                respostaUsuario.errorDescription,
                AlertType.error
              );
              return;
            }

            if (respostaEmpresa.isError) {
              this.alertService.show(
                'Erro ao buscar dados da empresa',
                respostaEmpresa.errorDescription,
                AlertType.error
              );
              return;
            }

            listaSuperAcessoResponse.listaSuperAcesso.forEach(item => {
              let usuarioEncontrado: UsuarioListaStruct | undefined;
              if (respostaUsuario.listaUsuario) {
                usuarioEncontrado = respostaUsuario.listaUsuario.find(
                  usuario => usuario.idUsuario === item.idUsuario
                );
              }
              if (usuarioEncontrado) {
                item.nomeUsuario = usuarioEncontrado.nomeUsuario;
              }

              let empresaEncontrada: Empresa | undefined;
              if (respostaEmpresa.list) {
                empresaEncontrada = respostaEmpresa.list.find(
                  empresa => empresa.idEmpresa === item.idEmpresa
                );
              }
              if (empresaEncontrada) {
                item.nomeEmpresa = empresaEncontrada.nomeEmpresa;
              }
            });

            this._dataSource.data = listaSuperAcessoResponse.listaSuperAcesso;
          },
        });
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar();
  }

  clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaPerfilResponse = undefined;
    this.pesquisar();
  }

  public async habilitaSelecaoUsuario(): Promise<void> {
    this.model.get('listaIdUsuario')?.enable();
    const idEmpresa = this.model.get('listaIdEmpresa')?.value;
    this.model.get('listaIdUsuario')?.setValue(null);

    if (idEmpresa) {
      await this.popularDadosUsuario(idEmpresa);
    }

    this.model.get('listaIdUsuario')?.enable();
  }

  async popularDadosUsuario(idEmpresa: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.usuarioAdminService.get(idEmpresa).subscribe({
        next: (listaUsuarioResponse: ListaUsuarioResponse) => {
          if (listaUsuarioResponse.isError) {
            this.alertService.show('Erro', listaUsuarioResponse.errorDescription, AlertType.error);
            return;
          }
          this._usuarioLookupResponse = listaUsuarioResponse;
          resolve();
        },
        error: (error: any) => {
          this.alertService.show('Erro inesperado', error, AlertType.error);
          reject();
        },
      });
    });
  }

  limpaCampos(): void {
    this.model.get('listaIdEmpresa')?.setValue(null);
    this.model.get('listaIdUsuario')?.setValue(null);
    this.model.get('listaIdUsuario')?.disable();
    this.model.get('datetimeInclusao')?.setValue(null);
  }

  public get listaIdEmpresaControl(): FormControl {
    return this.model.get('listaIdEmpresa') as FormControl;
  }
}
